import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Amplify, * as AmplifyModules from 'aws-amplify'
// @ts-ignore
import { AmplifyPlugin } from "aws-amplify-vue"
// @ts-ignore
import awsconfig from './aws-exports';
import vuetify from './plugins/vuetify';
import VueCurrencyFilter from 'vue-currency-filter'
//@ts-ignore
import VueTheMask from 'vue-the-mask';
//@ts-ignore
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2';
import VueApexCharts from 'vue-apexcharts';
import Component from 'vue-class-component';
import store from './store'
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave'
])
// Vue clipboard config
VueClipboard.config.autoSetContainer = true;

Vue.config.productionTip = false;
// Amplify config setup
// Auto Config from backend setup
Amplify.configure(awsconfig);
// Manual config setup for external resources created not through amplify
Amplify.configure({
    Auth: {

        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: process.env.VUE_APP_AUTH_IDENTITY_POOL_ID,

        // REQUIRED - Amazon Cognito Region
        region: process.env.VUE_APP_AWS_REGION,

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.VUE_APP_AUTH_USER_POOL_ID,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: process.env.VUE_APP_AUTH_WEB_CLIENT_ID,

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false, // To allow choice input

        clientMetadata: {
            client: 'admin-tool',
            requestFromAddress: window.location.origin
        },

        oauth: {
            domain: process.env.VUE_APP_AUTH_OAUTH_DOMAIN,
            scope: ['phone', 'email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
            redirectSignIn: process.env.VUE_APP_AUTH_OAUTH_REDIRECT_SIGN_IN,
            redirectSignOut: process.env.VUE_APP_AUTH_OAUTH_REDIRECT_SIGN_OUT,
            responseType: 'code'
        }

    },
    Storage: {
        AWSS3: {
            bucket: process.env.VUE_APP_STORAGE_S3_BUCKET, //REQUIRED -  Amazon S3 bucket
            region: process.env.VUE_APP_AWS_REGION, //OPTIONAL -  Amazon service region
        }
    },
    API: {
        endpoints: [
            {
                name: "Viewpoint360API",
                endpoint: process.env.VUE_APP_API_CORE_ENDPOINT,
                region: process.env.VUE_APP_AWS_REGION
            }
        ]
    },
    "aws_appsync_graphqlEndpoint": process.env.VUE_APP_COMMENT_GRAPHQL,
    "aws_appsync_region": process.env.VUE_APP_AWS_REGION,
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
});

Vue.use(VueTheMask);
Vue.use(VueCookies);
Vue.use(VueClipboard);
Vue.use(VueCurrencyFilter, {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
});
Vue.use(VueApexCharts);
Vue.use(AmplifyPlugin, AmplifyModules);

//Component definitions
Vue.component('apexchart', VueApexCharts);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

new Vue({
    router,
    // @ts-ignore
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
